import ListItem from '../../utils/ListItem';

function stripHtml(html) {
  if (!html) return '';
  return html.replace(/<[^>]*>/g, '').trim();
}

function MissionListItem(props) {
  return (
    <ListItem
      primary={props.name}
      secondary={stripHtml(props.details)}
      meta={props.date}
    />
  );
}

export default MissionListItem;
